
import { defineComponent } from "vue";
import { VBtn } from "vuetify/lib";

export default defineComponent({
  mixins: [VBtn],
  props: {
    elevation: {
      type: Number,
      default: 0,
    },
  },
});
